module.exports = __webpack_public_path__ + "img/list-bottom-light.cb63a82c.png";